import { Col, Form, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ScopeButton } from '../components/buttons';
import { FormSelect } from '../components/formSelect';

export type StaffMemberOption = { id: string; name: string };

type ChangeOwnerFormProps = {
  updateOwner: (accountId: string) => void;
  staffMembers: StaffMemberOption[];
};

export const ChangeOwnerForm = ({
  updateOwner,
  staffMembers,
}: ChangeOwnerFormProps) => {
  const { t } = useTranslation();
  return (
    <Form layout="vertical" onFinish={(values: { staffMember: string }) => updateOwner(values.staffMember)}>
      <Row>
        <Col span={24}>
          <Typography.Paragraph
            style={{
              fontSize: 16,
              color: 'var(--color-text-muted, #5a6a6a)',
              marginBottom: 40,
            }}
          >
            {t('other.transfer-ownership-description')}
          </Typography.Paragraph>
        </Col>
        <Col span={24}>
          <Form.Item
            name="staffMember"
            rules={[{ required: true, message: t('common.required-field') }]}
          >
            <FormSelect
              width="100%"
              height="45px"
              placeholder={t('other.select-user')}
              options={staffMembers.map((sm) => ({ value: sm.id, label: sm.name }))}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item>
            <div className="rows-drawer-footer">
              <ScopeButton type="primary" htmlType="submit">
                {t('users.change-owner')}
              </ScopeButton>
            </div>
          </Form.Item>
          <Typography.Text type="danger">
            {t('other.change-owner-warning')}
          </Typography.Text>
        </Col>
      </Row>
    </Form>
  );
};
